
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H12.8096C11.6888 20.8321 11 19.2465 11 17.5C11 13.9101 13.9101 11 17.5 11C18.0163 11 18.5185 11.0602 19 11.1739V4C19 2.89543 18.1046 2 17 2H4ZM16 7H5V9H16V7ZM5 12H9V14H5V12Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.134 15.0359L15.866 12.3038L16.5438 13.4777C18.6294 12.8038 20.9735 13.6502 22.1136 15.625C22.9932 17.1484 22.9321 18.9559 22.1143 20.3751L20.8147 19.6262C21.3761 18.6519 21.4156 17.416 20.8146 16.375C20.0916 15.1227 18.661 14.5336 17.3194 14.8212L17.866 15.7679L15.134 15.0359ZM15.1854 16.3738C14.6239 17.3481 14.5844 18.584 15.1854 19.625C15.9084 20.8773 17.339 21.4664 18.6806 21.1788L18.134 20.232L20.866 20.9641L20.134 23.6961L19.4563 22.5223C17.3706 23.1962 15.0265 22.3498 13.8864 20.375C13.0068 18.8515 13.0679 17.0441 13.8857 15.6249L15.1854 16.3738Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowrefreshpageFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
